<template>
  <div class="block">
    <el-cascader
      size="small"
      v-model="selectedOptions"
      :options="options"
      :props="{ value: 'id', label: 'name', expandTrigger: 'hover', checkStrictly: true }"
      @change="handleChange"
      @clean="handleChange"
      clearable 
      :disabled="isDisabled"
      style="width: 250px;"
    >
    </el-cascader>
  </div>
</template>
<script>
import SaleChannelService from "~/services/SaleChannel";
export default {
  name: "ChannelCascader",
  props: {
    isUrl: {
      type: Boolean,
      default: false
    },
    channel: {
      type: Object,
      required: false,
      value: function () {
          return {};
      }
    },
  },
  data() {
    return {
      selectedOptions: [],
      options: [],
      isDisabled: false
    };
  },
  mounted() {
    if (this.channel) {
      if(this.channel.pid > 0) {
        this.selectedOptions = [parseInt(this.channel.pid), parseInt(this.channel.id)];
      }else{
        this.selectedOptions = [parseInt(this.channel.id)];
      }
      if(this.channel.hasOwnProperty('url') && this.channel.url){
        this.isDisabled = true;
      }
    }
    this.getList({is_url: this.isUrl && !this.isDisabled ? 1 : 0});
  },
  methods: {
    // 获取销售渠道列表
    getList(params = {}) {
      SaleChannelService.getTreeList(params).then((res) => {
        if (res.code == 0) {
          this.options = res.data;
        }
      });
    },
    handleChange(value) {
      this.selectedOptions = value;
      this.$emit("change", value);
    },

    reset() {
      this.selectedOptions = [];
      this.$emit("change", []);
    }
  },
};
</script>




// WEBPACK FOOTER //
// src/widgets/ChannelCascader.vue